import { z } from 'zod';

export const deliverySchema = z.object({
    recipient_name: z.string().min(1, 'El nombre es obligatorio'),
    recipient_phone: z.string().min(1, 'El teléfono es obligatorio'),
    address_uuid: z.string().optional(),
    address: z.object({
        street: z.string().min(1, 'Calle obligatoria'),
        number: z.string().min(1, 'Altura obligatoria'),
        floor: z.string().optional(),
        apartment: z.string().optional(),
        district: z.string().min(1, 'Barrio obligatorio'),
        reference: z.string().optional(),
        latitude: z.number().optional(),
        longitude: z.number().optional(),
    }).optional(),
});

export const pickupSchema = z.object({
    pickup_name: z.string().min(1, 'El nombre es obligatorio'),
    pickup_phone: z.string().min(1, 'El teléfono es obligatorio'),
    customer_name: z.string().optional(),
});

export const scheduledOrderSchema = z.object({
    contact_email: z.string().email('Email inválido'),
    scheduled_times: z.record(z.string(), z.string().min(1, 'Horario requerido')),
});

export type DeliveryFormValues = z.infer<typeof deliverySchema>;
export type PickupFormValues = z.infer<typeof pickupSchema>;
